import { CreateTextEdit } from "./CreateTextEdit";
import { AddTextEdit } from "./AddTextEdit";

export function AddStdTextEdit(
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder
) {
  var te = CreateTextEdit();
  AddTextEdit(te, panel, xPos, yPos, width, height, blankMsg, maxLen, tabID, addBorder);
  return te;
}
